/*                                                              */
/**/

import { accepts } from "hono/accepts";
import type { Context } from "../runtime/context/context.types";

export const jsonMimes = ["application/json", "application/problem+json"] as const;

export const formMimes = ["application/x-www-form-urlencoded", "multipart/form-data"] as const;

export const headers = [
  "Content-Type",
  "Accept",
  "Location",
  "x-kestrel-fetch", /*                                                */
  "Authorization",
] as const;

export const cacheHeaders = ["Cache-Control", "Pragma", "Expires"] as const;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function acceptsJson(c: Context): boolean {
  /*                                                           */
  if (!c.req.header(headers[1])) return false;

  /*                                                                   */
  const cc = accepts(c, {
    header: "Accept",
    supports: [jsonMimes[0], "text/html"],
    default: "text/html",
  });

  return cc === jsonMimes[0];
}
